"use client";

import { useEffect } from "react";

import { env } from "../../../utils/libs/env";

// Widget de chat RomaAI para las vistas de recuperación de cuentas (front-account).
// Réplica de la config del login (LR-2549) para reusar el mismo canal de Team Roma.
// El script externo lee `window.romaAIConfig`, por eso se define antes de inyectarlo.
const WIDGET_SCRIPT_ID = "roma-ai-webchat-widget";
const WIDGET_SCRIPT_SRC = "https://app.teamroma.ai/webchat-widget.js";
const ROMA_AI_HOST = "app.teamroma.ai";

const ROMA_AI_CONFIG = {
  widgetId: "channel_1782419852510",
  flowId: "817",
  nodeId: "channel_1782419852510",
  chatName: "Chat de Soporte",
  primaryColor: "#1F61F7",
  secondaryColor: "#1F61F7",
  textColor: "#ffffff",
  logoUrl: "https://cms-manager-assets-prod.s3.us-east-1.amazonaws.com/callcenter.png",
  avatarUrl: "https://cms-manager-assets-prod.s3.us-east-1.amazonaws.com/callcenter.png",
  welcomeMessage: "Hola, estoy acá para ayudar con tu inicio de sesión... ¿Cómo te puedo ayudar?",
  welcomeButtons: [] as string[],
  enableFileUpload: false,
  collapsedLabel: "¿No puedes iniciar sesión?",
  fontSize: "medium",
  launcherSize: "medium",
  windowSize: "medium",
  bubbleWidth: "medium",
  showLauncherAvatar: true,
  launcherImageSource: "avatar",
  launcherImageUrl: "",
  showHeaderIcon: true,
  showMessageAvatar: false,
  botBubbleColor: "",
  botBubbleTextColor: "",
  chatPosition: "bottom-left",
  requireName: "none",
  requirePhone: "none",
  requireEmail: "none",
  whatsappNumber: "",
  whatsappText: "",
  instagramHandle: "",
  contactEmail: "",
  apiUrl: "https://app.teamroma.ai/api",
};

declare global {
  interface Window {
    romaAIConfig?: typeof ROMA_AI_CONFIG;
  }
}

export function RomaChatScript() {
  useEffect(() => {
    // Kill-switch por ambiente (NEXT_PUBLIC_CHATBOT_ENABLED). Si está en "false", el chatbot no se monta.
    if (env.NEXT_PUBLIC_CHATBOT_ENABLED === "false") return;

    // Inyectar CSS para mostrar solo icono en mobile
    const styleId = "roma-ai-widget-mobile-styles";
    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;
      style.textContent = `
        @media (max-width: 768px) {
          /* Solo el launcher (botón), no el chat window */
          iframe[src*="${ROMA_AI_HOST}"][style*="position: fixed"] {
            width: 60px !important;
            height: 60px !important;
          }
          
          /* Ocultar el texto del launcher en mobile */
          [class*="launcher"] [class*="label"],
          [class*="launcher"] [class*="text"],
          [class*="roma-launcher-text"],
          .roma-launcher-label {
            display: none !important;
          }
        }
      `;
      document.head.appendChild(style);
    }

    window.romaAIConfig = ROMA_AI_CONFIG;

    if (!document.getElementById(WIDGET_SCRIPT_ID)) {
      const script = document.createElement("script");
      script.id = WIDGET_SCRIPT_ID;
      script.src = WIDGET_SCRIPT_SRC;
      script.async = true;
      document.body.appendChild(script);
    }

    return () => {
      document.getElementById(WIDGET_SCRIPT_ID)?.remove();
      document.getElementById(styleId)?.remove();
      const romaFrames = document.querySelectorAll(`iframe[src*="${ROMA_AI_HOST}"]`);
      for (const iframe of Array.from(romaFrames)) {
        iframe.remove();
      }
      window.romaAIConfig = undefined;
    };
  }, []);

  return null;
}
